import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

const PKR = (n) => `Rs ${Number(n || 0).toLocaleString("en-PK")}`;

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { if (user) api.get("/my/orders").then((r) => setOrders(r.data)).catch(() => {}); }, [user]);

  if (loading) return <div className="pt-28 text-center text-zinc-500">Loading...</div>;
  if (!user) return (
    <div className="pt-28 text-center">
      <h1 className="font-serif text-3xl text-white">Please sign in</h1>
      <button onClick={() => { const r = window.location.origin + "/account"; window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(r)}`; }} className="btn-gold mt-5">Sign in with Google</button>
    </div>
  );

  return (
    <div className="pt-24 pb-16 max-w-4xl mx-auto px-4" data-testid="account-page">
      <div className="flex items-center gap-4 mb-8">
        {user.picture && <img src={user.picture} alt={user.name} className="w-14 h-14 rounded-full border border-amber-500/40" />}
        <div>
          <h1 className="font-serif text-3xl text-white">{user.name || "Guest"}</h1>
          <div className="text-zinc-400 text-sm">{user.email} · <span className="badge-gold ml-1">{user.role}</span></div>
        </div>
      </div>

      <h2 className="font-serif text-xl text-amber-200 mb-3">Your orders</h2>
      {orders.length === 0 && <div className="text-zinc-500">No orders yet. <Link to="/menu" className="text-amber-300">Browse the menu →</Link></div>}
      <div className="space-y-3">
        {orders.map((o) => (
          <Link to={`/track?o=${o.order_number}`} key={o.order_number} className="card-lux p-4 flex items-center justify-between" data-testid={`my-order-${o.order_number}`}>
            <div>
              <div className="font-mono text-amber-200">{o.order_number}</div>
              <div className="text-xs text-zinc-500">{new Date(o.created_at).toLocaleString()} · {o.items.length} items</div>
            </div>
            <div className="text-right">
              <div className="font-mono text-white">{PKR(o.total)}</div>
              <span className={`status-tag status-${o.status}`}>{o.status.replace(/_/g, " ")}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
